import { render, staticRenderFns } from "./DetailsCampaign.vue?vue&type=template&id=848b1a84&scoped=true&"
import script from "./DetailsCampaign.vue?vue&type=script&lang=js&"
export * from "./DetailsCampaign.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCampaign.vue?vue&type=style&index=0&id=848b1a84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848b1a84",
  null
  
)

export default component.exports